<template>
  <SizedCellWrapper :allow-overflow="true">
    <div class="main-doc-cell">
      <div class="thumb">
        <ExplodingThumbnail :thumb-id="docId"
                            :thumb-url="thumbUrl"
                            :is-selected="isSelected"
                            :is-floating="isFloating"
                            @click="emit('thumbnail-click')"
        />
      </div>

      <div class="details">
        <FilePathText :file-path="docTitle"/>

        <HeadlinesPreview v-if="textSearchStrings"
                          :doc_id="docId"
                          :text-search-strings="textSearchStrings"
                          :on-fetch-headlines="onFetchHeadlines"
        />

        <TagChicletContainer v-if="Array.isArray(tags) && tags.length"
                             :tags="tags"
        />
      </div>
    </div>
  </SizedCellWrapper>
</template>

<script setup>
  import SizedCellWrapper from "@/components/search-page/search-grid/custom-cells/SizedCellWrapper.vue";
  import HeadlinesPreview from "@/components/base-components/HeadlinesPreview.vue";
  import TagChicletContainer from "@/components/base-components/tags/TagChicletContainer.vue";
  import ExplodingThumbnail from "@/components/base-components/ExplodingThumbnail.vue";
  import FilePathText from "@/components/base-components/FilePathText.vue";

  const props = defineProps(["docTitle", "docId", "thumbUrl", "headlines", "tags", "isSelected", "isFloating", "textSearchStrings", "onFetchHeadlines"]);
  const emit = defineEmits(['thumbnail-click']);
</script>

<style lang="scss" scoped>
  .main-doc-cell {
    display: flex;
    gap: 1rem;

    .thumb {
      flex: 0 0 auto;
    }

    .details {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      flex: 1 1 auto;
      overflow: hidden;
      text-wrap: wrap;
    }
  }

  //.doc-title {
  //  font-size: 14px;
  //  line-height: 1.2;
  //  margin: 0 0 6px 0;
  //  overflow: hidden;
  //  text-overflow: ellipsis;
  //}
</style>
